import styled, { css, keyframes } from 'styled-components';

export const BouncingAnimation = keyframes`
  0% {
    margin-left: 40px;
  }
  10% {
    margin-left: -40px;
  }
  20% {
    margin-left: 40px;
  }
  100% {
    margin-left: 40px;
  }
`;

export const InitWrapper = styled.div`
  ${({ theme, $isFullScreen }) => css`
    font-family: ${theme.v2.font.family.primary};
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    overflow-x: hidden;

    ${$isFullScreen && css`
      margin: auto 0px;
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 100%;
      overflow: visible;
      > *:first-child {
        margin-top: auto;
      }
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: ${theme.v2.colors.neutral.highPure};
      border-radius: 40px;
      outline: ${theme.v2.colors.neutral.highMedium} solid 1px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${theme.v2.colors.neutral.highLight};
      border-radius: 40px;
      border: 2px solid ${theme.v2.colors.neutral.highPure};
      cursor: pointer;
      width: calc(100% - 4px);
    }
  `}
`;

export const AnimationIcon = styled.img`
  ${({ theme }) => css`
      border-radius: 50%;
      border: 1px solid ${theme.v2.colors.neutral.highMedium};
      height: 65px;
      width: 64px;
  `}
`;

export const WelcomeMessage = styled.span`
  ${({ theme, $isFullScreen }) => css`
    color: ${theme.v2.colors.neutral.lowLight};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    max-width: 266px;
    text-align: center;
    margin: unset;

    span {
      color: ${theme.v2.colors.brand.primaryExtraDark}
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm};
      margin: 0px auto auto;
    }

    ${$isFullScreen && css`
      align-items: center;
      display: flex;
      flex-direction: row;
      gap: 16px;
      margin: 0px 0px 24px 0px;
      max-width: unset;
    `}
  `}
`;

export const Suggestions = styled.span`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowMedium};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    margin-top: 32px;
  `}
`;

export const OptionsList = styled.ul`
${({ theme, $isFullScreen, $interacted }) => css`
    display: flex;
    flex-direction: ${$isFullScreen ? 'row' : 'column'};
    gap: 16px;
    list-style: none;
    margin: 16px 0px 0px;
    max-width: ${$isFullScreen ? 'unset' : '360px'};
    padding: 0px;
    width: 100%;

    ${$isFullScreen && css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      justify-content: flex-start !important;
      margin-left: 40px;
      overflow: scroll;
      width: calc(100% + 40px);

      &::-webkit-scrollbar {
        display: none;
      }
      scrollbar-width: none;
      -ms-overflow-style: none;

      ${!$interacted && css`
        animation: ${BouncingAnimation} 3s infinite;
      `}
    }
`}
`;

export const OptionItem = styled.li`
  ${({
    theme, $featured, $isFullScreen, $isDisabled,
  }) => css`
    display: flex;
    flex-direction: row;
    cursor: pointer;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border-radius: 16px;
    background-color: ${theme.v2.colors.neutral.highExtraLight};

    ${$isFullScreen && css`
      height: 140px;
      justify-content: space-between;
    `}


    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.xs}
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
    letter-spacing: -0.176px;

    &:hover {
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    }

    ${$featured && css`
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs}
    }

    ${($isFullScreen) && css`
      align-items: flex-start;
      flex-direction: column;
      gap: 16px;
      flex: 0 0 210px;
      width: 100%;
    `}

    ${($isDisabled) && css`
      cursor: default;

      &:hover {
        background-color: ${theme.v2.colors.neutral.highExtraLight};
      }
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      align-items: flex-start;
      flex-direction: column;
      gap: 16px;
      flex: 0 0 210px;
      width: 100%;
    }
  `}
`;

export const IconWrapper = styled.div`
  ${({ $isFullScreen }) => css`
  display: flex;
    width: ${$isFullScreen ? '100%' : 'unset'};
    justify-content: space-between;
  `}
`;

export const Tag = styled.span`
  ${({ theme }) => css`
    background: linear-gradient(180deg, #7BE5A3 0%, #CDFDDD 100%);
    border-radius: 8px;
    padding: 3px 8px;
    display: inline-flex;
    align-items: center;
    color: #227C55;
    font-size: ${theme.v2.font.sizes.xxxs};
    font-weight: ${theme.v2.font.weights.medium};
    line-height: ${theme.v2.font.lineHeight.text};
  `}
`;

export const FullScreenOptionItemLabel = styled.span`
  max-width: 150px;
`;

export const WhatCouldItDoForYouBorder = styled.span`
  ${({ $isFullScreen }) => css`
    background: linear-gradient(90deg, #2E93EE, #5E60CE);
    border-radius: 16px;
    margin: ${$isFullScreen ? '32px 0px 0px' : '16px 0px 0px'};
    max-width: 360px;
    padding: 1px;
    position: relative;
    width: 100%;
  `}
`;

export const WhatCouldItDoForYouButton = styled.button`
  ${({ theme, $featured, $isFullScreen }) => css`
    align-items: center;
    background: ${theme.v2.colors.neutral.highPure};
    border-radius: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: center;
    padding: 16px;
    width: 100%;

    border: 0px;

    ${$featured && css`
      background-color: ${theme.v2.colors.brand.primaryLowLight};
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs}
    }

    ${$isFullScreen && css`
      flex-direction: column;
      gap: 16px;
      align-items: flex-start;
    `}
  `}
`;

export const WhatCouldItDoForYouLabel = styled.span`
  ${({ theme }) => css`
      font-family: ${theme.v2.font.family.primary};
      background: linear-gradient(90deg, #2E93EE, #5E60CE);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-size: ${theme.v2.font.sizes.xs}
      font-weight: ${theme.v2.font.weights.medium};
      letter-spacing: -0.176px;
      line-height: ${theme.v2.font.lineHeight.text};
    `}
`;

export const AlertsCtaWrapper = styled.div`

`;
